import primitiveFactory from "_src/engine/factories/primitive";
import objFactory from "_src/engine/factories/object";
import {primitiveType} from "_src/engine/constants";
import LineShader from "_src/shaders/line/line";
import {lineColorType} from "_src/constants";

const LINE_WIDTH = 2;

export default class SectionAnalysisWidget {
  constructor(data) {
    this._contour1 = _createLine(data.contour1, data.color1);
    this._contour2 = _createLine(data.contour2, data.color2);
    this._whiskers = _createWhiskers(data.whisker1, data.whisker2, data.distances, data.tolerance);
    this._pickCountour = _createPickLine(data.whisker1, data.distances, data.distanceRange);
  }

  addToScenes(linesScene, pickScene) {
    linesScene.add(this._contour1);
    linesScene.add(this._contour2);
    linesScene.add(this._whiskers);
    pickScene.add(this._pickCountour);
  }

  removeFromScenes(linesScene, pickScene) {
    linesScene.remove(this._contour1);
    linesScene.remove(this._contour2);
    linesScene.remove(this._whiskers);
    pickScene.remove(this._pickCountour);
  }

  setVisibility(visible) {
    this._contour1.setVisibility(visible);
    this._contour2.setVisibility(visible);
    this._whiskers.setVisibility(visible);
    this._pickCountour.setVisibility(visible);
  }
}

function _createLine(points, color) {
  const shader = new LineShader({
    lineWidth : LINE_WIDTH,
    transparent : true,
    backFaceCulling: false,
    depthTest: false,
    screenSpace : false,
    colorType: lineColorType.UNIFORM,
  });
  const model = objFactory.createDrawable(shader);
  model.setDiffuseColor(...color);

  const primitives = [];
  for (let i = 1; i < points.length / 3; ++i) {
    primitives.push(i - 1, i);
  }

  model.addGeometryChunk(primitiveFactory.create(primitiveType.LINE_ARRAY, { points, primitives }));
  model.chunks[0].enableFrustumTest = false;

  return model;
}

function _createWhiskers(points1, points2, distances, tolerance) {
  const shader = new LineShader({
    lineWidth : LINE_WIDTH,
    transparent : true,
    backFaceCulling: false,
    depthTest: false,
    colorType : lineColorType.BUFFER,
    screenSpace : false,
    tolerance: tolerance,
  });

  const model = objFactory.createDrawable(shader);
  const points = points1.concat(points2);
  const attribute = [];
  const primitives = [];
  for (let i=0; i<points1.length / 3; i++) {
    attribute[i] = distances[i];
    attribute[points1.length / 3 + i] = distances[i];

    primitives.push(i, points1.length / 3 + i);
  }

  model.addGeometryChunk(primitiveFactory.create(primitiveType.LINE_ARRAY, { points, primitives, attribute }));
  model.chunks[0].enableFrustumTest = false;

  return model;
}

function _createPickLine(points, distances, distanceRange) {
  const shader = new LineShader({
    lineWidth : 1.0,
    transparent : false,
    backFaceCulling: false,
    depthTest: false,
    screenSpace : false,
    distanceRange: distanceRange,
    colorType: lineColorType.OUTPUT,
  });
  const model = objFactory.createDrawable(shader);

  const primitives = [];
  for (let i = 1; i < points.length / 3; ++i) {
    primitives.push(i - 1, i);
  }

  model.addGeometryChunk(primitiveFactory.create(primitiveType.LINE_ARRAY, { points, primitives, attribute: distances }));
  model.chunks[0].enableFrustumTest = false;

  return model;
}
